/**
 * dashboardCache.ts
 * In-memory client-side cache for dashboard views (SystemAdmin, PortfolioOverview).
 * Eliminates loading latency and full-page spinner flashes when navigating
 * between pages and returning to the Overview tab.
 */

export interface SystemAdminCache {
  stats: any;
  auditLog: any[];
  anomalyStats: any[];
  anomalyData?: any;
  properties: any[];
  allAlerts: any[];
  timestamp: number;
}

export interface PortfolioOverviewCache {
  overview: any;
  allAlerts: any[];
  anomalyStats: any[];
  anomalyData?: any;
  properties: any[];
  timestamp: number;
}

let systemAdminCache: SystemAdminCache | null = null;
let portfolioOverviewCache: PortfolioOverviewCache | null = null;

export function isTestEnv(): boolean {
  try {
    const proc = (globalThis as any).process;
    return typeof proc !== 'undefined' && proc?.env?.NODE_ENV === 'test';
  } catch {
    return false;
  }
}

export function getSystemAdminCache(): SystemAdminCache | null {
  if (isTestEnv()) return null;
  return systemAdminCache;
}

export function setSystemAdminCache(data: Omit<SystemAdminCache, 'timestamp'>): void {
  systemAdminCache = { ...data, timestamp: Date.now() };
}

export function getPortfolioOverviewCache(): PortfolioOverviewCache | null {
  if (isTestEnv()) return null;
  return portfolioOverviewCache;
}

export function setPortfolioOverviewCache(data: Omit<PortfolioOverviewCache, 'timestamp'>): void {
  portfolioOverviewCache = { ...data, timestamp: Date.now() };
}

export function clearDashboardCache(): void {
  systemAdminCache = null;
  portfolioOverviewCache = null;
}
